import 'bootstrap';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router.js';
// import { allowedImageType } from "./helpers.js";
import swalPlugins from './plugins/swal.js';
import lazyPlugin from 'vue3-lazy';
import loadImage from './../images/loading.gif';
import defaultPreview from './../images/default_preview.png';
import { RepositoryFactory } from './repositories/RepositoryFactory.js';

const userRepository = RepositoryFactory.get('userAdmin');

const app = createApp(App);

app.use(router);
app.use(swalPlugins);
app.use(lazyPlugin, {
    loading: loadImage,
    error: defaultPreview
});

app.mixin({
    data() {
        return {
            catchedError: null,
            errorFeedbacks: {},
        };
    },
    methods: {
        showErrorFeedback(error) {
            this.catchedError = error;
            this.errorFeedbacks = this.catchedError?.response?.data?.errors;
        },

        hideErrorFeedback() {
            this.errorFeedbacks = {};
        },

        errorFeedback(key) {
            try {
                return this.errorFeedbacks[key][0];
            } catch (error) {
                return false;
            }
        },

        clearErrorFeedback(key) {
            try {
                return this.errorFeedbacks[key][0] = null;
            } catch (error) {
                return false;
            }
        },

        stringIsNullOrEmpty(input) {
            if (input === null) return true;
            if (input === undefined) return true;
            if (input === "") return true;
            return false;
        },

        trucate(value, length = 30) {
            return value.length <= length ?
                value : value.substring(0, length) + "...";
        },

        slugify(str) {
            return str
                .toLowerCase()
                .trim()
                .replace(/[^\w\s-]/g, '')
                .replace(/[\s_-]+/g, '-')
                .replace(/^-+|-+$/g, '');
        },

        allowedImageType(file) {
            // Get file extension
            const fileType = file.name.split('.').at(-1);
            return ACCESS_FILE_IMAGE_TYPE.includes(fileType);
        },
    },
});

app.mount("#app");

export default {};
